import React, { Component, Fragment } from 'react';
import {Helmet} from "react-helmet";
import Breadcrumb from "../../../common/breadcrumb";
import {clear_auth, set_auth} from "../../../../reducers/Auth";
import {connect} from "react-redux";
import {Empty, Spin, Tooltip} from "antd";
import {pageNumber} from "../../../../functions/functionGeneral";
import Paging from "../../../paging";
import PlusIcon from "../../../../assets/icons/plus-white.svg";
import Add from "./add";
import Edit from "./edit";
import Import from "./import"
import Swal from "sweetalert2";
import refreshIcon from "../../../../assets/icons/refresh.svg";
import Chart from "react-google-charts";
import List from "../../../../assets/icons/master.svg"
import Calender from "../../../../assets/icons/calendar.svg"
import {BACKEND_API_HOST} from "../../../../helper/host";
import MoreIcon from "../../../../assets/icons/more.svg";
import SearchIcon from "../../../../assets/icons/search.svg";
import { PERMISSIONS } from "../../../../helper/permissionHelper";
import { withPageAccess } from "../../../common/ProtectedPage";
import {TourContext} from "../../../guideComponent/guideTourProvicer";

class Finance extends Component {
    static contextType = TourContext;
  constructor(props) {
    super(props);
    this.state = {
      data : [],
      dataTerm: [],
      currentPage : 0,
      list: true,
      income: true,
      outcome: true,
      selected: null
    }
  }

  loadData() {
    this.setState({loading: true})
    let form = {
      keyword     : this.state.keyword,
      type        : this.state.type,
      paginate    : 10,
      page        : this.state.currentPage + 1,
    }
    this.props.request("finance/list", form, 'POST')
      .then(response => {
        if (response && response.success) {
          this.setState({
            data: response.data.data,
            loading: false,
            totalData: response.data.total,
            pageCount: response.data.last_page,
            perPage: response.data.per_page,
          })
        }
      });
  }

  loadTerm() {
    this.props.request("finance_term/list", {})
      .then(response => {
        if (response && response.success) {
          this.setState({
            dataTerm : response.data.data
          })
        }
      })
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleDelete() {
    Swal.fire({
      title: 'Pemberitahuan!',
      text: 'Anda yakin ingin menghapus?',
      icon: 'warning',
      confirmButtonText: 'Ya',
      showCancelButton: true,
      cancelButtonText: 'Batal',
    })
      .then((result) => {
        if (result.isConfirmed) {
          let form = {
            finance_id    : this.state.finance_id
          }
          this.props.request("finance/delete", form, 'POST')
            .then(response => {
              if (response && response.success) {
                Swal.fire({
                  title: 'Berhasil!',
                  text: response.message,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 800,
                })
                this.loadData()
              }
            });
        }
      })
  }

  handlePageClick = (data) => {
    let selected = data.selected
    this.setState({ currentPage: selected }, () => {
      this.loadData()
    });
  }

  export = () => {
    var AuthKey = localStorage.getItem('Presensi-Auth-Key')
    window.open(BACKEND_API_HOST + 'finance/export?token=' + AuthKey, "_blank")
  }

  componentDidMount() {
    this.loadData()
    this.loadTerm()
  }

  componentDidUpdate(prevProps, prevState) {
      if (prevState.loading === true && this.state.loading === false) {
          this.tourTimeout = setTimeout(() => {
              const tourSteps = [];

              tourSteps.push(
                  {
                      selector: '.pengumuman-filter-nama-input',
                      title: 'Cari Data Keuangan',
                      content: 'Gunakan kolom pencarian ini untuk mencari data keuangan berdasarkan deskripsi atau kategori. Tekan Enter untuk memulai pencarian.'
                  },
                  {
                      selector: '.input-select-style.select-column',
                      title: 'Filter Tipe',
                      content: 'Gunakan filter ini untuk menampilkan data keuangan berdasarkan tipe: Income atau Outcome.'
                  },
                  {
                      selector: '.button-reset',
                      title: 'Reset Filter',
                      content: 'Klik tombol ini untuk mengembalikan seluruh filter ke pengaturan awal dan memuat ulang data.'
                  }
              );

              tourSteps.push(
                  {
                      selector: '.btn.mb-2.mr-2.px-2',
                      title: 'Tampilan List / Grafik',
                      content: 'Klik tombol ini untuk beralih antara tampilan daftar (tabel) dan tampilan grafik data keuangan.'
                  }
              );

              if (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) {
                  tourSteps.push({
                      selector: '.btn.btn-primary.text-capitalize',
                      title: 'Tambah Data',
                      content: 'Klik tombol ini untuk menambahkan data keuangan baru ke dalam sistem.'
                  });
              }

              tourSteps.push({
                  selector: '.btn.border.border-dark',
                  title: 'Import / Export',
                  content: 'Klik tombol ini untuk membuka menu Import atau Export data keuangan dalam format file.'
              });

              if (!this.state.loading && this.state.data.length === 0) {
                  tourSteps.push({
                      selector: '.table-responsive',
                      title: 'Daftar Data Keuangan (Kosong)',
                      content: 'Belum ada data keuangan yang tersedia. Gunakan pencarian atau ubah filter untuk melihat data.'
                  });
              } else if (this.state.list) {
                  tourSteps.push(
                      {
                          selector: '.table-responsive',
                          title: 'Daftar Data Keuangan',
                          content: `Tabel ini menampilkan ${this.state.data.length} data keuangan beserta informasi tanggal, tipe, kategori, jumlah, dan deskripsi.`
                      }
                  );

                  if (
                      (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) ||
                      (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("D") >= 0)
                  ) {
                      tourSteps.push({
                          selector: '.fa-ellipsis-v',
                          title: 'Aksi',
                          content: 'Klik ikon titik tiga untuk membuka menu aksi pada setiap data keuangan, seperti Edit atau Hapus.'
                      });
                  }
              } else {
                  tourSteps.push({
                      selector: '.market-chart',
                      title: 'Grafik Data Keuangan',
                      content: 'Grafik ini menampilkan visualisasi data keuangan dalam bentuk area chart. Klik ikon list di kiri atas untuk beralih ke tampilan tabel.'
                  });
              }

              const { setSteps, setCurrent, setActive } = this.context;
              setSteps(tourSteps);
              setCurrent(0);
              setActive(true);
          }, 500);
      }
  }

  componentWillUnmount() {
      clearTimeout(this.tourTimeout);
  }

  render() {
    let no = 0;

    const groupedData = {};

    this.state.data.forEach(item => {
      const termId = item.fin_term_id;
      const termName = item.finance_term?.fin_term_name || "Unknown";
      const jumlah = Number(item.finance_jumlah);

      if (!groupedData[termId]) {
        groupedData[termId] = {
          fin_term_id: termId,
          fin_term_name: termName,
          finance_jumlah: 0,
        };
      }

      groupedData[termId].finance_jumlah += jumlah;
    });

    const formattedData = Object.values(groupedData)
      .sort((a, b) => a.fin_term_id - b.fin_term_id);

    const chartData = [
      ["Kategori", "Jumlah"],
      ...formattedData.map(item => [item.fin_term_name, item.finance_jumlah]),
    ];

      return (
        <Fragment>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Daftar Laporan Keuangan - Presensi</title>
            <meta name="description" content="Daftar Laporan Keuangan" />
          </Helmet>
          <Breadcrumb parent="Settings" title="Daftar Laporan Keuangan"/>
          <Add
            handleChange={this.handleChange}
            modal_add={this.state.modal_add}
            data={this.state}
            request={(action, data, method = 'GET') => this.props.request(action, data, method)}
            changeState={(state, callback) => {
              this.setState(state, () => {
                if (typeof callback != 'undefined')
                  callback()
              })
            }}
            loadData={() => this.loadData()}
          />
          <Edit
            handleChange={this.handleChange}
            modal_edit={this.state.modal_edit}
            data={this.state}
            request={(action, data, method = 'GET') => this.props.request(action, data, method)}
            changeState={(state, callback) => {
              this.setState(state, () => {
                if (typeof callback != 'undefined')
                  callback()
              })
            }}
            loadData={() => this.loadData()}
          />
          <Import
            handleChange={this.handleChange}
            modalImport={this.state.modalImport}
            data={this.state}
            request={(action, data, method = 'GET') => this.props.request(action, data, method)}
            changeState={(state, callback) => {
              this.setState(state, () => {
                if (typeof callback != 'undefined')
                  callback()
              })
            }}
            loadData={() => this.loadData()}
          />
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-4 d-flex pr-md-1">
                    <button className="btn mb-2 mr-2 px-2" onClick={() => this.setState({list: !this.state.list})}>
                      <img src={this.state.list ? List : Calender} alt=""/>
                    </button>
                    {this.state.list &&
                      <div className="input-group form-search mr-1">
                        <span className="input-group-text pengumuman-filter-nama-input-text">
                          <img alt='' src={SearchIcon}/>
                        </span>
                        <input
                          type="text" onChange={this.handleChange}
                          name='keyword' value={this.state.keyword}
                          className="form-control pengumuman-filter-nama-input"
                          placeholder="Cari deskripsi atau kategori ..."
                          onKeyUp={(e) => {
                            if (e.key === "Enter") {
                              this.loadData()
                            }
                          }}
                        />
                      </div>
                    }
                  </div>
                  <div className="col-md-3 px-md-1 d-flex flex-row flex-nowrap mb-2">
                    {this.state.list &&
                      <>
                        <select
                          className="form-control input-select-style select-column w-100 mr-2 mt-0"
                          onChange={(e) => this.setState({type: e.target.value}, this.loadData)}
                          style={{marginLeft: "0"}}
                        >
                          <option value="" selected={this.state.type === ''}>Pilih Tipe</option>
                          <option value="income">Income</option>
                          <option value="outcome">Outcome</option>
                        </select>
                        <div>
                          <button className="input-select-style button-reset mt-0"
                                  style={{width: "44px"}} onClick={() => {
                            this.setState({
                              keyword: "",
                              type: ""
                            }, () => this.loadData())
                          }}>
                            <img src={refreshIcon} alt=""/>
                          </button>
                        </div>
                      </>
                    }
                  </div>
                  <div className='d-flex col-md-5 justify-content-end' style={{gap: 10}}>
                    {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) && (
                      <button className='btn btn-primary text-capitalize mb-2' onClick={() => this.setState({
                        modal_add: true
                      })}><img alt='' src={PlusIcon}/> Tambah
                      </button>
                    )}
                    <Tooltip className="mb-2" trigger={'click'} placement={'bottomRight'} color={'#fff'} title={
                      <div className="p-2">
                        <a className="text-dark" onClick={() => this.setState({
                          modalImport: true,
                        })}>Import</a><br/>
                        <a className="text-dark" onClick={this.export}>Export</a>
                      </div>
                    }>
                      <a><i
                        style={{
                          width: "46px",
                          alignContent: "center",
                          fontSize: 18,
                          color: 'rgb(51 51 51)',
                          height: "46px",
                          paddingRight: "30px"
                        }}
                        className='btn border border-dark border-1 px-2'
                      ><img src={MoreIcon}/></i></a>
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      {!this.state.loading && this.state.data.length === 0 ?
                        <Empty description="Data Kosong"
                               image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"/>
                        :
                        this.state.list === true ?
                          <div>
                            {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("R") >= 0) && (
                              <table className="table mb-5 table-striped table-borderless">
                                <thead>
                                <tr>
                                  <th className='lembur-th-style text-center' width="50">#</th>
                                  <th className='lembur-th-style'>Tanggal</th>
                                  <th className='lembur-th-style'>Tipe</th>
                                  <th className='lembur-th-style'>Kategori</th>
                                  <th className='lembur-th-style'>Jumlah</th>
                                  <th className='lembur-th-style'>Deskrips</th>
                                  <th className='lembur-th-style text-center'>Aksi</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.loading ?
                                  <tr>
                                    <td colSpan="9" style={{
                                      textAlign: "center",
                                      backgroundColor: "#FFFFFF"
                                    }}>
                                      <Spin size="large"
                                            tip="Sedang Memuat Data"
                                            style={{
                                              width: '100%',
                                              margin: 'auto',
                                              marginBottom: '10px',
                                              marginTop: '10px'
                                            }}/>
                                    </td>
                                  </tr>
                                  :
                                  this.state.data.map((item, index) => {
                                    no += 1
                                    return (
                                      <tr key={index}>
                                        <td
                                          className="lembur-td-style text-center">{pageNumber(no, this.state.perPage, this.state.currentPage)}</td>
                                        <td className="lembur-td-style">{item.finance_date}</td>
                                        <td className="lembur-td-style">{item.finance_term.fin_term_type}</td>
                                        <td className="lembur-td-style">{item.finance_term.fin_term_name}</td>
                                        <td className="lembur-td-style">{item.finance_jumlah}</td>
                                        <td className="lembur-td-style">{item.finance_desc}</td>
                                        <td className="lembur-td-style text-center">
                                          <Tooltip
                                            trigger={'click'} zIndex={1} placement="bottom" color={'#fff'}
                                            title={
                                              <div className={'text-dark'}>
                                                {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) && (
                                                  <a onClick={() => {
                                                    this.setState({
                                                      finance_id: item.finance_id,
                                                      finance_cat: item.finance_cat,
                                                      fin_term_id: item.fin_term_id,
                                                      finance_jumlah: item.finance_jumlah,
                                                      finance_date: item.finance_date,
                                                      finance_desc: item.finance_desc,
                                                      modal_edit: true
                                                    })
                                                  }}>Edit</a>
                                                )}
                                                <br/>
                                                {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("D") >= 0) && (
                                                  <a onClick={() => {
                                                    this.setState({
                                                      finance_id: item.finance_id
                                                    })
                                                    this.handleDelete()
                                                  }} className={'text-danger'}>Hapus</a>
                                                )}
                                              </div>
                                          }>
                                            <a><i
                                              className="fa fa-ellipsis-v"
                                              style={{
                                                width: 35,
                                                fontSize: 18,
                                                padding: 11,
                                                color: 'rgb(51 51 51)'
                                              }}
                                            ></i></a>
                                          </Tooltip>
                                        </td>
                                      </tr>
                                    )
                                  })}
                                </tbody>
                              </table>
                            )}
                          </div>
                          :
                          <>
                            <div className="market-chart" style={{height: "510px"}}>
                              <Chart
                                data={chartData}
                                chartType="AreaChart"
                                options={{
                                  curveType: "function",
                                  legend: "none",
                                  vAxis: {gridlines: {color: "transparent"}},
                                }}
                                width={"100%"}
                                height={500}
                              />
                            </div>
                          </>
                      }
                    </div>
                    <div className="row">
                      <div className='col font-14 fw-500 m-auto'>
                        Menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} dari {this.state.totalData} Data.
                      </div>
                      <div className="col">
                        <Paging
                          className="float-right"
                          handlePageClick={this.handlePageClick}
                          pageCount={this.state.pageCount}
                          currentPage={this.state.currentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user,
  api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
  clear_auth: () => dispatch(clear_auth()),
  set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withPageAccess(Finance, PERMISSIONS.KEUANGAN));